export const COUNTRY_DIAL_CODE_LOCAL_SETTINGS_KEY = 'COUNTRY_DIAL_CODE_LOCAL_SETTINGS_KEY';
export const SHOW_PHONE_TEXT_INPUT_LOCAL_SETTINGS_KEY = 'SHOW_PHONE_TEXT_INPUT_LOCAL_SETTINGS_KEY';